import { ReactNode, useEffect, useState } from "react";
import { Box, Stack } from "@mui/material";
import { TriangleIcon } from "../images";

interface Props {
  header: ReactNode;
  children: ReactNode;
  expandHandler: () => void;
  shouldExpand?: boolean;
  expand?: boolean;
}

export const CustomAccordion = ({
  header,
  children,
  expand = false,
  shouldExpand,
  expandHandler,
}: Props) => {
  const [expanded, setExpanded] = useState<boolean>(expand);

  useEffect(() => {
    setExpanded(expand);
  }, [expand]);

  useEffect(() => {
    shouldExpand && setExpanded(true);
  }, [shouldExpand]);

  useEffect(() => {
    expanded && setTimeout(() => expandHandler(), 350);
  }, [expanded]);

  return (
    <Stack
      sx={{
        flexGrow: 1,
      }}
    >
      <Stack
        onClick={() => setExpanded(!expanded)}
        sx={{
          flexDirection: "row",
          alignItems: "center",
          flexWrap: "nowrap",
          gap: "4px",
          cursor: "pointer",
        }}
      >
        <Stack
          sx={{
            justifyContent: "center",
            alignItems: "center",
            color: expanded ? "primary.main" : "text.secondary",
            transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.5s ease",
          }}
        >
          <TriangleIcon />
        </Stack>
        {header}
      </Stack>

      <Box
        sx={{
          overflow: "hidden",
          transform: expanded ? "scaleY(1)" : "scaleY(0)",
          transformOrigin: "top",
          height: expanded ? "auto" : 0,
        }}
      >
        {children}
      </Box>
    </Stack>
  );
};
